import { Directive, input } from '@angular/core';
import { DialogComponent } from './dialog.component';

let idSequence = 0;

@Directive({
  selector: 'button[libDialogCloseFor]',
  standalone: true,
  host: {
    '[id]': 'id()',
    '(click)': 'hide()',
    'aria-haspopup': 'dialog',
    '[attr.aria-expanded]': 'this.dialog()?.isOpen()',
    '[attr.data-state]': 'this.dialog()?.isOpen()',
  },
  exportAs: 'libDialogCloseFor',
})
export class DialogCloseDirective {
  readonly id = input(`dialog-hide-${idSequence++}`);

  dialog = input.required<DialogComponent | null>({
    alias: 'libDialogCloseFor',
  });

  hide() {
    this.dialog()?.hide();
  }
}
